// @flow
import { makeApiCall } from '../../../../services/apiService/apiService';
import envConfig from '../../../../configs/envConfig';

export const crmCallActions = {
  CRM_CALLING: 'CRM_CALLING'
};

export const crmCallingAction = (load: Object) => ({
  type: crmCallActions.CRM_CALLING,
  payload: load
});

const getCrmCallingFailurePayload = (dispatch, res) => {
  const defaultErrorMsg = 'Could not fetch reasons';
  dispatch(
    crmCallingAction({
      waitForForm: false,
      uuid: null,
      supersetCall: false,
      displayErrorMessage: (res && res.errorMessage) || defaultErrorMsg
    })
  );
};

const callStatusUpdateCall = (callTriggered, uui) => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'callStatusUpdate',
    method: 'PUT',
    data: {
      callTriggered,
      uui
    },
    successCb: res => {
      if (res.status === 'SUCCESS') {
        console.log('Call status update success', res);
      } else if (res.status === 'FAILURE') {
        console.log('Call status update failure', res);
      }
    },
    failureCb: res => {
      console.log('Call status update failure', res);
    },
    catchCb: res => {
      console.log('Call status update failure', res);
    }
  };
  return makeApiCall(requestObj);
};

const fetchSupersetCall = (dispatch, obj, res) => {
  let supersetUrl = envConfig.crmOzoneTelCall;
  supersetUrl = supersetUrl.replace('#emailId', res.payload.userEmail);
  supersetUrl = supersetUrl.replace('#uuid', obj.uuid);
  supersetUrl = supersetUrl.replace('#mobileNumber', obj.customerNumber);
  supersetUrl = supersetUrl.replace('#userName', obj.userName);
  supersetUrl = supersetUrl.replace('#apiKey', obj.apiKey);
  supersetUrl = supersetUrl.replace('#campaignName', obj.campaignName);
  fetch(supersetUrl)
    .then(response => response.text())
    .then(str => new window.DOMParser().parseFromString(str, 'text/xml'))
    .then(
      data =>
        data.getElementsByTagName('status')[0] &&
        data.getElementsByTagName('status')[0].childNodes[0] &&
        data.getElementsByTagName('status')[0].childNodes[0].nodeValue
    )
    .then(val => {
      if (val === 'queued successfully') {
        callStatusUpdateCall(true, obj.uuid);
        dispatch(
          crmCallingAction({
            supersetCall: true,
            waitForForm: false
          })
        );
      } else {
        callStatusUpdateCall(false, obj.uuid);
        dispatch(
          crmCallingAction({
            waitForForm: false,
            uuid: null,
            supersetCall: false,
            displayErrorMessage: val
          })
        );
        if (obj.fetchPollingInterval) {
          clearInterval(obj.fetchPollingInterval);
        }
      }
    });
};

export const getCrmCalling = (obj: Object) => (dispatch: Function) => {
  obj = obj.state;
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'crmCall',
    method: 'GET',
    pathVariables: [{ key: '#uuid', val: obj.uuid }],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        if (!res.payload.data) {
          return;
        }
        let url = envConfig.crmGoogleForm;
        url = url.replace('#uuid', obj.uuid);
        url = url.replace('#name', res.payload.userName);
        dispatch(
          crmCallingAction({
            formSrc: url,
            apiData: res.payload,
            showCallReasonsModal: true,
            supersetCall: false
          })
        );
        if (obj.fetchPollingInterval) {
          clearInterval(obj.fetchPollingInterval);
        }
      } else if (res.status === 'FAILURE') {
        getCrmCallingFailurePayload(dispatch, res);
        if (obj.fetchPollingInterval) {
          clearInterval(obj.fetchPollingInterval);
        }
      }
    },
    failureCb: res => {
      getCrmCallingFailurePayload(dispatch, res);
      if (obj.fetchPollingInterval) {
        clearInterval(obj.fetchPollingInterval);
      }
    },
    catchCb: res => {
      getCrmCallingFailurePayload(dispatch, res);
      if (obj.fetchPollingInterval) {
        clearInterval(obj.fetchPollingInterval);
      }
    }
  };
  return makeApiCall(requestObj);
};

export const postCallInitiate = (obj: Object) => (dispatch: Function) => {
  const { callType, callId, apiKey, userName } = obj;
  obj = obj.state;
  const crmCallVendor = obj.crmCallVendor && obj.crmCallVendor.key;

  dispatch(
    crmCallingAction({
      uuid: obj.uuid,
      displayErrorMessage: obj.displayErrorMessage,
      supersetCall: obj.supersetCall,
      waitForForm: obj.waitForForm,
      formSrc: obj.formSrc,
      apiData: obj.apiData,
      showCallReasonsModal: obj.showCallReasonsModal
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'crmInitiate',
    method: 'POST',
    pathVariables: [{ key: '#uuid', val: obj.uuid }],
    params: {
      callType,
      callId,
      crmCallVendor
    },
    successCb: res => {
      if (res.status === 'SUCCESS') {
        if (!obj.supersetCall) {
          fetchSupersetCall(
            dispatch,
            {
              apiKey,
              userName,
              campaignName: res.payload.campaignName,
              customerNumber: obj.customerNumber,
              uuid: obj.uuid
            },
            res
          );
        }
      } else if (res.status === 'FAILURE') {
        getCrmCallingFailurePayload(dispatch, res);
      }
    },
    failureCb: res => {
      getCrmCallingFailurePayload(dispatch, res);
    },
    catchCb: res => {
      getCrmCallingFailurePayload(dispatch, res);
    }
  };
  return makeApiCall(requestObj);
};

export const postCallReasons = (callData: Object) => (dispatch: Function) => {
  const obj = callData.state;
  let reasonData;
  if (callData && callData.showReasonsModal) {
    reasonData = {
      uui: obj.uuid,
      callType: callData.callType,
      callId: callData.callId,
      callReason: obj.callReason
    };
  } else {
    reasonData = obj.apiData;
    reasonData.callReason = obj.callReason;
  }

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'crmCallReasons',
    method: 'PUT',
    data: reasonData,
    successCb: res => {
      if (res.status === 'FAILURE') {
        getCrmCallingFailurePayload(dispatch, res);
      }
    },
    failureCb: res => {
      getCrmCallingFailurePayload(dispatch, res);
    },
    catchCb: res => {
      getCrmCallingFailurePayload(dispatch, res);
    }
  };
  return makeApiCall(requestObj);
};
